import { Input } from '@material-tailwind/react'
import { formatRut as formatRutValue } from 'react-rut-formatter'

export const DocumentNumberInput = ({
  value,
  onChange,
  formatAsRut = true,
  maxLength,
  ...props
}) => {
  const effectiveMaxLength = formatAsRut ? maxLength ?? 10 : maxLength

  const handleChange = (e) => {
    if (formatAsRut) {
      e.target.value = formatRutValue(e.target.value)
    } else {
      e.target.value = e.target.value.toUpperCase()
    }

    onChange?.(e)
  }

  return (
    <Input
      onChange={handleChange}
      maxLength={effectiveMaxLength}
      value={value ?? ''}
      {...props}
    />
  )
}
